import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {
    Card, CardBody, CardTitle,
    Col,
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    Row, Spinner
} from 'reactstrap';
import {
    CURRENCY_MXN_HEADER,
    CURRENCY_USD_HEADER,
    error,

    infoMsg,

    saveMsg,
    success
} from "../../../../components/i18n/i18n";
import {dishDrinkPriceService} from "../../../../jwt/_services/ayb/dishDrinkPriceService";
import {showToastCustom} from "../../../../components/toast/customToast";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {TT_CLOSE, TT_DELETE, TT_SAVE} from "../../../../components/i18n/toolTips";
import Separator from "../../../../components/Separator";

export const TreatmentSectionPrices = forwardRef((props, ref) => {
    const [parent] = useState(props.parent || null);

    const [app] = useState(props.app || null);

    const [modal, setModal] = useState(false);

    const [item, setItem] = useState(null);

    const [saving, setSaving] = useState(false)
    const [prices, setPrices] = useState( []);
    const [durationOptions, setDurationOptions] = useState( []);
    const currencies = ['USD', 'MXN']

    useImperativeHandle(ref, () => ({
        showModal(_item, _index) {

            _item.prices.map(price => {
            });

            setItem( _item );
            setPrices(_item.prices || []);
            setDurationOptions(_item.durationOptions || []);
            setModal(!modal);
        }
    }));


    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    const showModal = () => {
        setModal(!modal);
    }

    const onSubmit = () => {
        const dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                items : prices
            }
        }

        setSaving(true)
        dishDrinkPriceService.saveItem(dataRequest)
            .then(result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
                setModal(!modal);
            })
            .catch( e => {
                    console.log("Error en la asignacion", e);
                    showToastCustom(error, infoMsg, true);
                }
            )
            .finally(() => {
                if(isMounted.current) {
                    setSaving(false)
                }
                props.refreshList();
                setModal(!modal);
            });
    };

    const getPriceOf = (duration, currency) => {
        const price = prices.find(p => p.presentationType === duration && p.currencyCode === currency )

        return price?.price || 0.00
    }

    const setPriceOf = (duration, currency, value) => {
        const priceIndex = prices.findIndex(p => p.presentationType === duration && p.currencyCode === currency )
        const _prices = prices.slice();

        if (priceIndex !== -1) {
            _prices[priceIndex] = {
                ..._prices[priceIndex],
                price : value
            }
        } else {
            _prices.push({
                currency : { currency : currency },
                currencyCode : currency ,
                dishDrink : { id : item.id },
                presentationType : duration,
                price : value
            })
        }

        setPrices(_prices);
    }

    return( <Modal isOpen={modal} toggle={showModal} modalClassName="menu-modal-form">
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > {  parent?.title + '  /  ' + (item?.title || ' / Precios') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + item?.uid }</h5>
                    </>
                    <div className="top-right">

                        {
                            saving ? <>
                                    <Spinner animation="border" size='sm' type='grow'/>
                                    <Spinner animation="border" size='sm' type='grow'/>
                                    <Spinner animation="border" size='sm' type='grow'/>
                                </> :
                                <GenericButton
                                    style={'table'}
                                    icon={'fa-save'}
                                    toolTip={TT_SAVE}
                                    permission={'add'}
                                    onClick={onSubmit}
                                />
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={showModal}
                        />
                    </div>
                </CardTitle>
                <CardBody>
                    <Row>
                        <Col md={"4"}/>
                        {
                            currencies.map((currency) => {
                                return (
                                    <Col md={"4"}><h4
                                        style={{textAlign: 'center'}}>{currency === 'USD' ? CURRENCY_USD_HEADER : CURRENCY_MXN_HEADER}</h4>
                                    </Col>
                                );
                            })
                        }
                    </Row>
                    {
                        durationOptions.map((option) => {
                            return (
                                <Row>
                                    <Col md={"4"}>{option.id + ' mins'}</Col>
                                    {
                                        currencies.map((currency) => {
                                            return (
                                                <Col md={"4"} style={{borderRight: 'solid'}}>
                                                    <InputGroup>
                                                        <InputGroupText>$</InputGroupText>
                                                        <Input
                                                            type="number"
                                                            step=".01"
                                                            min="0.00"
                                                            value={getPriceOf(option.id, currency)}
                                                            onChange={e => setPriceOf(option.id, currency, e.target.value)}
                                                            placeholder={''}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            );
                                        })
                                    }
                                </Row>
                            );
                        })
                    }
                </CardBody>
            </Card>
    </Modal>
    );
})